import styled from 'styled-components';
import TrackRefundSvg from '../../assets/mytrips/track-refund.svg';

const TrackRefundIcon = styled(TrackRefundSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default TrackRefundIcon;
